// Product Accordion with Calculated Height Animation
// Best Practice: Allow multiple tabs open on both desktop and mobile
document.addEventListener('DOMContentLoaded', function() {
  const accordions = document.querySelectorAll('.product-accordion__item');
  
  accordions.forEach(accordion => {
    const summary = accordion.querySelector('.product-accordion__summary');
    const panel = accordion.querySelector('.product-accordion__panel');
    
    if (!summary || !panel) return;
    
    summary.addEventListener('click', function(e) {
      e.preventDefault();
      
      const isOpen = accordion.hasAttribute('open');
      
      if (isOpen) {
        // Closing
        panel.style.height = panel.scrollHeight + 'px';
        panel.offsetHeight; // Force reflow
        panel.style.height = '0px';
        
        setTimeout(() => {
          accordion.removeAttribute('open');
          panel.style.height = '';
        }, 250);
        
      } else {
        // Opening
        accordion.setAttribute('open', '');
        accordion.classList.add('is-animating');
        
        const endHeight = panel.scrollHeight;
        panel.style.height = '0px';
        panel.offsetHeight; // Force reflow
        
        requestAnimationFrame(() => {
          panel.style.height = endHeight + 'px';
        });
        
        setTimeout(() => {
          accordion.classList.remove('is-animating');
          panel.style.height = '';
        }, 400);
      }
    });
  });
});